import { render, staticRenderFns } from "./LikeDislikeComponent.vue?vue&type=template&id=36f5c44c&scoped=true"
import script from "./LikeDislikeComponent.vue?vue&type=script&lang=ts"
export * from "./LikeDislikeComponent.vue?vue&type=script&lang=ts"
import style0 from "./LikeDislikeComponent.vue?vue&type=style&index=0&id=36f5c44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5c44c",
  null
  
)

export default component.exports